<template>
  <router-view />
</template>

<script>
export default {
  name: "app-labelType"
};
</script>

<style lang="scss" scoped></style>
